import { useLocation } from 'react-router-dom';
import { useEffect, useMemo, useRef } from 'react';
import { useBackgroundNavigate } from './use-background-navigate';

export const useSearchParams = <T = Record<string, string>>() => {
  const remove = useRef<(name: string) => void>(() => {});
  const location = useLocation();
  const navigate = useBackgroundNavigate();

  const searchParams = useMemo<T>(() => {
    const searchParams = new URLSearchParams(location.search);

    return Object.fromEntries(searchParams.entries()) as unknown as any;
  }, [location.search]);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    remove.current = (name: string) => {
      searchParams.delete(name);
      navigate({ pathname: '', search: searchParams.toString() });
    };
  }, [navigate, location.search]);

  return { searchParams, remove };
};
